// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HJsHg","content":"styles_content__jEE5f"};